import React, { useEffect } from "react";

import { ReactComponent as CloseSVG } from "../../../assets/notifyClose.svg";
import useSound from "use-sound";
import notificationSFX from "../../../assets/audio/globals/notificationSFX.mp3";
import {
  NotificationContainer,
  Icon,
  NotificationBox,
  NotWrapper,
} from "./NotificationStyled";
import { OPWrapper } from "../settings/SettingsStyled";

export default function Notification({
  notifyText,
  handleNotification,
  fadeOut,
  userSettings,
}) {

  const [playNotificationSFX] = useSound(notificationSFX, {
    volume: userSettings.volume,
  });
  useEffect(() => {
    if (userSettings.sound === "1") {
      playNotificationSFX();
    }
  }, [userSettings.sound, playNotificationSFX]);
  return (
    <NotificationContainer fadeOut={fadeOut}>
      <OPWrapper>
        <NotWrapper>
          <NotificationBox
            fadeOut={fadeOut}
            onClick={() => handleNotification(false)}
          >
            <Icon />
            <p>{notifyText}</p>
            <CloseSVG onClick={() => handleNotification(false)} />
          </NotificationBox>
        </NotWrapper>
      </OPWrapper>
    </NotificationContainer>
  );
}
